import React from 'react'
import { Link } from 'react-router-dom'

export default function FeaturedItemsItemDetails(props) {
  return (
    <div className="row justify-content-center">
              <Link className="col-8 col-md-10 card full-card-div div-zoom" to={props.link}>
                <div className='img-hover-zoom'>
                <img
                  src={props.img}
                  alt="img"
                  className="img-fluid small-feature-photo w-100 pt-2"
                />

                </div>
                <div className="d-flex">
                  <h6 className="card-title">
                    {props.title}
                  </h6>
                  <Link
                    to={props.link}
                    className="card-link ml-auto"
                  >
                    More info
                  </Link>
                </div>
              </Link>
            </div>
  )
}
